export const TYPE_FIELD_LIST = {
  TEXTFIELD: "textfield",
  SELECT: "select",
  SELECT_SEARCH: "select-search",
  DYNAMIC_SELECT: "dynamic-select",
  FILE: "file",
  TEXT: "text",
  ICONBTN: "icon-button",
  BTN: "button",
  ARRAY: "array",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  MONEY: "money",
  LINK: "link",
  PHONE_NUMBER: "phone-number",
};
